"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ComparisonTitle_1 = require("./ComparisonTitle");
exports.default = ComparisonTitle_1.default;
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idp/ui-components/components/cards/CardComparisonContainer/components/ComparisonTitle/index.js
// module id = 1328
// module chunks = 8